import { useState } from "react";
import { useParams } from "react-router-dom";
import { getStoredAccountType } from "../auth";
import { parseEmployeeRouteId } from "../lib/employeeRouteId";
import { EmployeesPage } from "./EmployeesPage";
import { EnterpriseEmployeesPage } from "./EnterpriseEmployeesPage";
import { EnterpriseEmployeeDetailPage } from "./EnterpriseEmployeeDetailPage";

export function EmployeesPageRouter() {
  const [accountType] = useState(() => getStoredAccountType());
  const { id } = useParams();
  const employeeId = parseEmployeeRouteId(id);

  if (!Number.isNaN(employeeId) && employeeId > 0) {
    if (accountType === "enterprise" || accountType === "admin") {
      return <EnterpriseEmployeeDetailPage employeeId={employeeId} />;
    }
  }

  if (accountType === "enterprise") {
    return <EnterpriseEmployeesPage />;
  }

  return <EmployeesPage />;
}
